import type { Repub } from '@cx-modules/constants';
import { REPUBS } from '@cx-modules/constants';

import styles from './Filters.module.css';

export type MarketGroupAndName = [string, string];

export interface FiltersProps {
  dataTestId?: string;
  handleMarketChange: (marketGroupName: string) => void;
  marketGroupNames: string[];
  repub: Repub;
  selectedMarketGroup: string;
}

export const Filters = ({
  dataTestId,
  handleMarketChange,
  marketGroupNames,
  repub,
  selectedMarketGroup
}: FiltersProps) => {
  const stylesRef = repub === REPUBS.OC.name ? 'oc' : 'default';
  const filtersContainerClassNames = [
  styles.filtersContainer,
  styles[stylesRef]].
  join(' ');

  return (
    <div
      className={filtersContainerClassNames}
      data-testid={dataTestId || 'filters'}>

			{marketGroupNames.map((marketGroup) => {
        const isActive = selectedMarketGroup === marketGroup;

        const filterClassNames = [
        styles.filter,
        styles[stylesRef],
        isActive ? styles.active : ''].
        join(' ');

        return (
          <button
            className={filterClassNames}
            data-testid="filter-button"
            key={marketGroup}
            onClick={() => {
              handleMarketChange(marketGroup);
            }}>

						{marketGroup}
					</button>);

      })}
		</div>);

};